module.exports = __webpack_public_path__ + "static/media/harvest-icon.89794909.png";